/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular.module('prism-ui.components.data').factory('CategoriesResourceFactory', function ($resource: JS5Function, EndPointService: JS5Object) {
    return $resource(EndPointService.categoriesEndPoint, {},
        {
            createCategory: {
                method: 'POST',
                url: `${EndPointService.packageCategoriesEndpoint}`,
                isArray: false
            },
            getAllCategories: {
                method: 'GET',
                url: `${EndPointService.packageCategoriesEndpoint}`,
                isArray: true,
            },
            getCategory: {
                method: 'GET',
                url: `${EndPointService.packageCategoriesEndpoint}/:id`,
                isArray: false,
                id: '@id'
            },

            getCategoryTypes: {
                method: 'GET',
                url: `${EndPointService.packageEndPoint}/categoryTypes?view=MINIMAL`,
                isArray: true
            },
            updateCategory: {
                method: 'PUT',
                url: `${EndPointService.packageCategoriesEndpoint}`,
                isArray: false,
            },
            deleteCategory: {
                method: 'DELETE',
                url: `${EndPointService.packageCategoriesEndpoint}/:id`,
                isArray: false,
            }
        });
});
